import ServerUtils from '@root/core/src/api/server-utils';
import pick from '@root/vendor/lodash/pick';

export async function isValidLicenseNumberForMarket(params) {
  const { data } = await ServerUtils.authenticatedGet('/web_api/license_number/validate', {
    query: pick(params, ['licenseNumber', 'market', 'driversLicenseId']),
  });
  return data;
}
